const apiUrl = process.env.REACT_APP_API_URL;
export const GetJBbddProblemesId = async (problemaId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/problemes/${problemaId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
